<script src="./mvt-poimarker.js"> </script>
<template>
  <CustomMarker :options="{ position }" class="pin-poi" :class="{'pin-selected': isSelected}">
    <div class="mvt-poimarker" ref="markerRef">
      <div
          class="mvt-poimarker__marker" :class="poi.poiTypeName"
          @click="() => setSelected()"
          ref="buttonRef"
      >
        <div
            class="mvt-poimarker__dot"
        >
          <i :class="iconClass"></i>
        </div>
      </div>
      <div
          v-if="isSelected && !disablePopup"
          ref="cardRef"
          class="mvt-poimarker__card"
          :style="`--property-market-x: ${positionX}%; --property-market-y: ${positionY}%; visibility: ${isVisibility ? 'visible' : 'hidden'};`"
      >
        <mvtCardPoi :data="poi" />
      </div>
    </div>
  </CustomMarker>
</template>

<style lang="scss">

.mvt-poimarker {

  position: relative;

  --map-marker-color-bg: var(--color-poi);
  --map-marker-color-border: var(--color-f);
  --map-marker-color: var(--color-f);
  --map-marker-color-bg-hover: var(--color-main);
  --map-marker-color-border-hover: var(--color-f);
  --map-marker-color-hover: var(--color-f);

  &__marker {
    z-index: 1;
    transform-origin: center center;
  }

  &__dot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    background-color: var(--map-marker-color-bg);
    border-radius: 50%;
    box-shadow: 0 0 0 2px var(--map-marker-color-border);
    color: var(--map-marker-color);
    transition: transform 0.1s ease-in;
    cursor: pointer;
    &:hover{
      transform: scale(1.5);
      background-color: var(--map-marker-color-bg-hover);
    }
  }

  &__card {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(var(--property-market-x), var(--property-market-y));
    width: 22.5rem;

    &-image {
      height: 106px;
      width: 163px;
      background-color: gray;
    }

    &-text {
      display: flex;
      flex-direction: column;
    }

  }

  .pin-poi{
    z-index: 10;
}
.pin-school{
    z-index: 49;
}

.pin-house{
    z-index: 40;
    &.mini{
        z-index: 30;
    }
    &.sold{
        z-index: 39;
    }
    &.new, &.hot{
        z-index: 41;
    }
    &.viewed {
        z-index: 42;
    }
    &.favorite {
        z-index: 43;
    }
    &.home{
        z-index: 50;
    }

}

.pin-hover {
    z-index: 99 !important;
}
.pin-selected {
    z-index: 100 !important;
}
.pin-hover, .pin-selected  {
    .mvt-poimarker .mvt-poimarker__dot,
    .mvt-schoolmarker .mvt-schoolmarker__dot {
        transform: scale(1.5);
        cursor: pointer;
        background-color: var(--map-marker-color-bg-hover);
    }
    .mvt-propertymarker {
        .mvt-propertymarker__dot,
        .mvt-propertymarker__price {
            color: var(--map-marker-color-hover);
            background-color: var(--map-marker-color-bg-hover);
            box-shadow: 0 0 0 1px var(--map-marker-color-border-hover), var(--map-marker-box-shadow);
            transform: scale(1.5);
        }

        .mvt-propertymarker__pin {
            color: var(--map-marker-color-bg-hover);
            transform: scale(1.5);
        }
    }
}
}

</style>